import { Drawer } from '@mui/material'
import { Header } from './Header'
import { WhatsNewList } from './WhatsNewList'
import { WhatsNewDocument } from './model/types'

type Props = {
  documents: WhatsNewDocument[]
  isOpen: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose: () => any
}

export const WhatsNewDrawer = ({ documents, isOpen, onClose }: Props) => (
  <Drawer anchor="right" open={isOpen} sx={{ zIndex: ({ zIndex }) => zIndex.appBar + 1 }} onClose={onClose}>
    <Header onClose={onClose} />
    <WhatsNewList documents={documents} />
  </Drawer>
)
